import { apps, average } from '@10000/common'
import { useView } from '@10000/react'
import { BackButton, Body, Box, H3 } from '../widgets'
import { useAnalyticsData } from '.'
import { action, recommendedGame, indexFromValue, practiceTips } from '../../lookups'
import { assetUrl, randomiseLetters } from '../../utilities.js'
import './NextSteps.scss'

export const NextSteps = ({ displayMode, onClose }) => {
  const { active, practice, subpractice } = useAnalyticsData()
  const { options } = useView('squiz')
  const question = practice * 2 + subpractice
  const value = active?.teamAverage?.[question] && average(active?.teamAverage?.[question])
  const { game, why } = recommendedGame[question] || {}

  // TODO: some practices have more than 10 - revise
  const tips = practiceTips[question]?.slice(0, 10)

  return (
    <Box
      column
      fullWidth
      fullHeight
      px={32}
      background="black"
      className="next-steps"
    >
      {!displayMode && <BackButton onClick={onClose} />}

      <Box fullWidth justifyContent="center" pb={20}>
        <H3>Next Steps</H3>
      </Box>

      <Box
        fullWidth
        justifyContent="space-around"
        className="mobile-column"
      >
        <Box
          column
          fullWidth
          maxWidth={700}
          gap={32}
          pb={32}
        >
          <Box column gap={8}>
            <Body alt weight={600} uppercase>
              What should we be working on?
            </Body>
            <H3 align="left">
              {value !== undefined && action[question][indexFromValue(value)]}
            </H3>
          </Box>

          {game &&
            <Box column gap={16} cursor="pointer" onClick={() => window.open(`https://podandhive.com/games/${game}/`)}>
              <Body alt weight={600} uppercase>You should try playing</Body>

              <Box alignItems="center" gap={16}>
                <img src={assetUrl(`games/${game}.png`)} alt="game" />

                <Box column>
                  <Body alt weight={600} lineHeight={1}>{apps[game].title}</Body>
                  <Body size={12}>Game</Body>
                </Box>
              </Box>

              <Body maxWidth={630}>
                🎯 <b>WHY:</b> {why}
              </Body>
            </Box>
          }
        </Box>

        <Box
          column
          fullWidth
          maxWidth={700}
          gap={20}
          pb={32}
        >
          <Body alt weight={600}>
            🪄🔮 TIPS & TRICKS
          </Body>
          <Box column fullWidth gap={8} grow overflow="auto">
            {tips?.map((tip, i) =>
              <Tip
                key={i}
                color={tipColors[i]}
                background={tipBackgrounds[i]}
                content={tip}
                blurred={options?.free && i > 2}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const Tip = ({ background, color, content, blurred }) => (
  <Box
    fullWidth
    p="16px 24px"
    r={16}
    alignItems="center"
    border="1px solid white"
    background={background}
    color={color}
    filter={blurred && 'blur(5px)'}
  >
    <Body alt weight={600} lineHeight={1.1}>
      {blurred ? randomiseLetters(content) : content}
    </Body>
  </Box>
)

const tipBackgrounds = ['var(--yellow)', 'var(--blue)', 'var(--red)', 'white', 'var(--skyblue)', 'var(--babypink)', 'var(--yellow)', 'white', 'var(--blue)', 'var(--red)']
const tipColors = ['black', 'white', 'white', 'black', 'black', 'black', 'black', 'black', 'white', 'white']

